export default __webpack_public_path__ + "static/zaiper-8bacc7e4bfd4311a998a434a07304c8d.png";